import React, {useContext, useEffect, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import {useLoaderData} from "react-router";
import {Card} from "../../../../components/card/card.jsx";
import HeaderTemplateButton from "../../../../components/button/header-template-button.jsx";
import {BoShowContext} from "./context/bo-show-context.jsx";
import BoShowStatusWarning from "./components/bo-show-status-warning.jsx";
import BoShowInitialData from "./components/bo-show-initial-data.jsx";
import BoShowOccurrenceData from "./components/bo-show-occurrence-data.jsx";
import BoShowIndividuals from "./components/bo-show-individuals.jsx";
import BoShowCompanies from "./components/bo-show-companies.jsx";
import BoShowApprehensions from "./components/bo-show-apprehensions.jsx";
import BoShowStolenItems from "./components/bo-show-stolen-items.jsx";
import BoShowVehicles from "./components/bo-show-vehicles.jsx";
import BoShowCroqui from "./components/bo-show-croqui.jsx";
import BoShowOtherDocuments from "./components/bo-show-other-documents.jsx";
import BoShowOtherInformation from "./components/bo-show-other-information.jsx";
import BoShowAgentReport from "./components/bo-show-agent-report.jsx";
import BoShowRectification from "./components/bo-show-rectification.jsx";
import BoShowLastSignature from "./components/bo-show-last-signature.jsx";
import BoShowInfos from "./components/bo-show-infos.jsx";
import BoShowButtons from "./components/bo-show-buttons.jsx";
import BoInvalidate from "../components/bo-invalidate.jsx";
import {toast} from "react-toastify";
import BoShowAddRectification from "./components/bo-show-add-rectification.jsx";
import BoShowAddOtherDocuments from "./components/bo-show-add-other-documents.jsx";
import {FaClockRotateLeft, FaFilePen, FaGears} from "react-icons/fa6";
import Button from "../../../../components/button/button.jsx";
import BoShowVersionModal from "./components/bo-show-version-modal.jsx";
import {BoKeys} from "../resources/bo-keys.js";
import {FaCopy, FaExternalLinkAlt, FaPrint} from "react-icons/fa";
import BoShowPrintModal from "./components/bo-show-print-modal.jsx";
import ModalAttaches from "../../../../components/modal/modal-attaches.jsx";
import BoShowFullImage from "./components/bo-show-full-image.jsx";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import BoShowTagsModal from "./components/bo-show-tags-modal.jsx";
import useHasPermission from "../../../../hooks/use-has-permission.js";
import {PermissionEnum} from "../../../../utils/enums/permission-enum.js";
import BosShowTagsList from "./components/bos-show-tags-list.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";
import STimeline from "../../../../components/icons/timeline.jsx";
import FormBuilderModal from "../../form-builder/modal/form-builder-modal.jsx";

const BoShow = () => {
    const context = useContext(BoShowContext);
    const {id, dataFetch, boData, isLoadingFetch, isLoading, setIsLoading, refetch, modalAttach, setModalAttach, dispatchId, tagsId = []} = context;

    const navigate = navigateHook();
    const hasPermission = useHasPermission();

    const status = dataFetch?.bogcm?.bogcm?.status ?? ""
    const canViewBogcmTag = hasPermission(PermissionEnum.BOGCM_VIEW_ALL);
    const canViewReportTimeline = hasPermission(PermissionEnum.REPORT_DISPATCH_BO_TIMELINE);

    const loaderData = useLoaderData();

    const [headerSelected, setHeaderSelected] = useState(-1);
    const [versionModal, setVersionModal] = useState(false);
    const [printModal, setPrintModal] = useState(false);
    const [tagsModal, setTagsModal] = useState(false);
    const [formModal, setFormModal] = useState({open: false, object: undefined});

    const printRef = useRef(undefined);

    useEffect(() => {
      if(id && loaderData?.bo_full_name) document.title = loaderData.bo_name + " - " + id
    }, [loaderData, id]);

    return (
        <>
            <Template isLoading={isLoadingFetch || isLoading}>
                <Template.Header>
                    <Template.Title browserTitle={`${loaderData?.bo_name} ${id}`} className={"flex gap-2 items-center"}>
                        {
                            id &&
                            <span className={"cursor-pointer"} onClick={() => projectUtils.copyToClipboard(id, `Número do ${loaderData?.bo_name} copiado.`)}>
                                <FaCopy size={16}/>
                            </span>
                        }
                        <span>{loaderData?.bo_name} {id} ({BoKeys[status] ?? status})</span>
                        {
                            !!dispatchId &&
                            <span className={"cursor-pointer"} onClick={() => navigate("/despacho/dispatch/form/" + dispatchId, true)}>
                                <FaExternalLinkAlt size={16}/>
                            </span>
                        }
                        {tagsId?.length > 0 && (
                            <BosShowTagsList
                                tags={tagsId}
                            />
                        )}
                    </Template.Title>

                    <div className={"flex gap-2"}>
                        {canViewReportTimeline && (
                            <>
                                <Button className={"px-0! py-0!"} title={"Linha do tempo"} onClick={() => navigate(`/reports/bo_timeline?id=${id.replace('/', '-')}`, true)}>
                                    <STimeline size={9} className={'w-[47px] p-2.05'}/>
                                </Button>
                            </>
                        )}
                        {canViewBogcmTag && (
                            <Button title={"Marcadores"} onClick={() => setTagsModal(true)}>
                                <img src={getAssetPath("img/bos-list/icon-tag.svg")} alt=""
                                     className="w-3.75" aria-hidden="true"/>
                            </Button>
                        )}

                        <Button title={"Versões"} onClick={() => setVersionModal(true)}><FaClockRotateLeft /></Button>
                        <Button title={"Formulários"} onClick={() => setFormModal({open: true, object: boData})}><FaFilePen /></Button>
                        <Button title={"Opções de impressão"} onClick={() => setPrintModal(true)}><FaGears size={18} /></Button>
                        <Button title={"Imprimir"} onClick={() => printRef.current?.print()}><FaPrint /></Button>

                        <HeaderTemplateButton selected={headerSelected} setSelected={setHeaderSelected}/>
                    </div>
                </Template.Header>

                <Template.Body>
                    <Card className={"w-[1030px] justify-self-center"}>
                        <Card.Body className={"!p-6"}>
                            <PrintTemplate title={loaderData?.bo_full_name + ' - ' + loaderData?.bo_name + ' ' + id} ref={printRef} entity={headerSelected} printClassName={"resume-content"}>
                                {
                                    boData?.initialData &&
                                    <div className={"space-y-4 p-2"}>
                                        <BoShowStatusWarning boName={loaderData?.bo_name}/>

                                        <BoShowInitialData />

                                        <BoShowOccurrenceData />

                                        <BoShowIndividuals />

                                        <BoShowCompanies />

                                        <BoShowApprehensions />

                                        <BoShowStolenItems />

                                        <BoShowVehicles />

                                        <BoShowCroqui />

                                        <BoShowOtherDocuments />

                                        <BoShowOtherInformation />

                                        <BoShowAgentReport />

                                        <BoShowRectification />

                                        <BoShowLastSignature />

                                        <BoShowInfos />

                                        <BoShowButtons />

                                        <BoShowAddRectification />

                                        <BoShowAddOtherDocuments />

                                        {
                                            dataFetch?.bogcm?.actions?.invalidate &&
                                            <hr className={"opacity-25 text-[#676a6c] print:hidden"}/>
                                        }

                                        <BoInvalidate
                                            id={id}
                                            boName={loaderData?.bo_name}
                                            setIsLoading={setIsLoading}
                                            actionsItems={dataFetch?.bogcm?.actions}
                                            callBack={() => {
                                                refetch();
                                                toast.success("Invalidado com sucesso");
                                            }}
                                        />

                                        <BoShowFullImage />
                                    </div>
                                }
                            </PrintTemplate>
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>

            <BoShowTagsModal
                open={tagsModal}
                setOpen={setTagsModal}
            />

            <BoShowVersionModal
                open={versionModal}
                setOpen={setVersionModal}
            />

            <BoShowPrintModal
                printRef={printRef}
                open={printModal}
                setOpen={setPrintModal}
            />

            <ModalAttaches
                open={modalAttach.open}
                setOpen={() => setModalAttach(prev => ({...prev, open: false}))}
                file={modalAttach.attach}
            />

            <FormBuilderModal
                module={"BO_GCM"}
                object={formModal.object}
                open={formModal.open}
                externalId={id}
                setOpen={(open) => setFormModal(prev => ({...prev, open}))}
                setIsLoading={setIsLoading}
                canCreateNewForms={status === "DRAFT"}
            />
        </>
    );
};

export default BoShow;